import React, { MouseEventHandler } from 'react';

import { Col } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';
import { PhoneIcon, Notes } from '@assets/icons';

import { Title, Button, ButtonText, SubTitle, Wrapper } from './styled';

export enum AlertType {
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
}
export interface AlertProps {
  title?: string;
  description?: string;
  type?: AlertType;
  onClick: MouseEventHandler;
}

const Alert = ({
  title = '',
  description = '',
  type = AlertType.PRIMARY,
  onClick = () => false,
}: AlertProps) => (
  <Wrapper color={type}>
    <Col>
      <Title color={type}>{title}</Title>
      <SubTitle color={type}>{description}</SubTitle>
      <Button color={type} onClick={onClick}>
        <CustomIcon
          fill='white'
          icon={type === AlertType.PRIMARY ? PhoneIcon : Notes}
        />
        <ButtonText color={type}>
          {type === AlertType.PRIMARY ? 'Sizi Arayalım' : 'Kontenjan Talep Et'}
        </ButtonText>
      </Button>
    </Col>
  </Wrapper>
);

export default Alert;
